import React from 'react'
import { MdOutlineWork, MdWork } from 'react-icons/md'
import { GiGraduateCap } from 'react-icons/gi'
import { RiBuildingFill } from 'react-icons/ri'
import { BiCalendar } from 'react-icons/bi'
import { MdDescription } from 'react-icons/md'
import PageTitle from '../components/PageTitle'
import { resume as data } from '../data'
import { FaLaptopCode } from 'react-icons/fa'

const Resume = () => {
  const {edu, exp, skills} = data
  return (
    <section className='resume-page'>
      <PageTitle title='Resume' />
      <div>
      <div className="title">
        <MdOutlineWork/>
        <h4>Experince</h4>
      </div>
      <div className="content">
          {exp.reverse().map(({id, date, company, postition, link, desc}) => {
          return(
            <div className='step-container' key={id}>
              <div className='item'>
                <BiCalendar/>
                <span className='date'>{date}</span>
              </div>
              <div className='item'>
              <MdWork/>
              <h5>{postition}</h5>
              </div>
              <div className='item'>
                <RiBuildingFill/>
                <a target='_blank' href={link} rel="noreferrer">{company}</a>
              </div>
              <div className='item'>
                <MdDescription />
                <p>{desc || 'There is no description for this position.'}</p>
              </div>
            </div>
          )
        })}
      </div>
      </div>
      <div>
      <div className="title">
          <GiGraduateCap />
      <h4>Education</h4>
      </div>
      <div className="content">
          {edu.map(({ id, date, title, desc, link, subTitle }) => {
          return(
            <div className='step-container' key={id}>
            <div className="item">
              <BiCalendar/>
              <span className='date'>{date}</span>
              </div>
              <div className="item">
                <MdWork/>
                <h5>{title}</h5>
              </div>
              <div className="item">
                <RiBuildingFill/>
                <a target='_blank' href={link} rel="noreferrer">{subTitle}</a>
              </div>
              <div className="item">
                <MdDescription/>
                <p>{desc}</p>
              </div>
            </div>
          )
        })}
      </div>

        <div className="title">
          <FaLaptopCode />
          <h4>Skills</h4>
          </div>
          <div className="skills">
            {
              skills.map(({img, title}, idx) =>{
                return(
                  <div className="img" key={idx}>
                    <img src={img} title={title} alt={title} />
                  </div>
                )
              })
            }
          </div>
      </div>
    </section>
  )
}

export default Resume